import { cronosClient } from "@/config/client"

export interface WeeklyObjectiveApproval {
  status: "pending" | "approved" | "rescheduled"
  name: string
  totalTime: number
  score: number
  approvedWeeklyObjectives: number
  totalWeeklyObjectives: number
  skippedActivities: number
  skippedActivitiesTime: number
}

export interface WeeklyObjectiveApprovalResponse {
  description: WeeklyObjectiveApproval
}

export default function getWeeklyObjectiveApproval(id: string) {
  return cronosClient
    .get<WeeklyObjectiveApprovalResponse>(`/v1/weekly-objectives/${id}/approval`)
    .then((resp) => resp.data.description)
}
